import { render, staticRenderFns } from "./SearchPatient.vue?vue&type=template&id=b7efb948&"
import script from "./SearchPatient.vue?vue&type=script&lang=js&"
export * from "./SearchPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports